import {
  ChangeDetectorRef, Component, EventEmitter, Input,
  OnChanges, OnInit, Output, Pipe, PipeTransform, SimpleChanges
} from '@angular/core';
import { DatasetRepo, FSPresetItem, XcHelpResult } from '@gspwidget/util';
import { FilterSchema, FSEnumItem } from '@gspwidget/util';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.css'],
  // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FilterComponent implements OnInit, OnChanges {
  /** 用于获得 enum 列的值 */
  /** filter 里绝不应该需要完整数据，否则参与查询的筛选还有啥意义？ */
  // @Input() intactData: any[] = []
  @Input('filterSchema') fs: FilterSchema
  @Input() openPicker //打开日期选择框
  @Output() singleValueChange = new EventEmitter()
  @Output() multiValueChange = new EventEmitter()

  value
  curItemsDatasetResult: any[]
  // 性能考虑
  curEnumItems: FSEnumItem[] = []
  curPresetItems: FSPresetItem

  delayOpenPicker: boolean = false;
  curLang: string
  constructor(
    public translate: TranslateService,
    public datasetRepo: DatasetRepo,
    public cd: ChangeDetectorRef,
    private route: ActivatedRoute,
  ) {
    this.curLang = this.translate.currentLang
   }

  ngOnInit() {
    //  setTimeout(()=>{
    this.aaa()
    //  },1000)
  }
  threeDays() {  //最近三天

  }
  sevenDays() { //最近七天

  }
  halfYear() { //最近半年

  }
  aaa() {
    if (this.openPicker !== undefined && this.openPicker !== null && this.openPicker !== '') {
      this.delayOpenPicker = this.openPicker;
    }
  }

  async ngOnChanges(changes: SimpleChanges) {
    // 第一次初始化、之后 fs 变更，都触发此初始化流程。
    // 注意最终运行时 fs 不会变
    if (changes.fs && changes.fs.currentValue !== changes.fs.previousValue) {
      const { queryParams } = this.route.snapshot
      this.value =  queryParams[this.fs.code] || await FilterSchema.getDefaultValue(this.fs)
      if (this.fs.type === 'enum') {
        if (this.fs.enum.source === 'dataset') {
          this
            .datasetRepo
            .getResultByDatasetId(this.fs.enum.itemsDatasetId)
            .subscribe(res => {
              this.curItemsDatasetResult = res
              this.updateDatasetEnumItems()

              //获取到下拉options之后在检测更新，否则赋值失败
              this.cd.markForCheck()
            })
        } else if (this.fs.enum.source === 'manual') {
          this.setCurEnumItems(this.fs.enum.itemsManual)
          //获取到下拉options之后在检测更新，否则赋值失败
          this.cd.markForCheck()
        }
      }
      else {
        // this.value = await FilterSchema.getDefaultValue(this.fs)
        this.cd.markForCheck()
        // }
      }
    }
  }
  /**
   * 外部（配置时）直接调用此方法设置新的 enum items
   */
  public setEnumItems(enumItems: FSEnumItem[]) {
    this.curEnumItems = enumItems
  }

  private updateDatasetEnumItems() {
    if (!this.curItemsDatasetResult) return
    this.setCurEnumItems(
      this.curItemsDatasetResult.map(item => ({
        label: item[this.fs.enum.itemsLabelField],
        value: item[this.fs.enum.itemsValueField],
      }))
    )
  }
  /**
   * 设置当前 enum items，运行时只会初始 set 一次。
   * @param enumItems 
   */
  private setCurEnumItems(enumItems: FSEnumItem[]) {    
    this.curEnumItems = enumItems.map(item => {      
      return {
        ...item,        
        displayLabel: this.resolveLabel(item)
      };
    });
  }

  private resolveLabel(item: FSEnumItem): string {
    if (item.label === null || item.label === undefined) {
      return item.value; 
    }    
    if (typeof item.label === 'string') {
      return item.label;
    }     
    if (typeof item.label === 'object') {      
      return item.label[this.curLang] || item.value;
    }
    return item.value;
  }


  handleDateChange(value) {
    this.handleChange(value)
  }
  handleChangeDateMulti(values: any[]) {
    this.handleChangeMulti(values)
  }
  /**
   * filter 不关心外界如何看待、处理多个值（多个值对应一个还是多个 dp），
   * 仅把多个值的数组发出去
   */
  handleChange(value) {
    this.singleValueChange.emit(value)
  }
  handleChangeMulti(values: any[]) {
    this.multiValueChange.emit(values)
  }

  handleStorePreset({ selected: presetItems }: XcHelpResult<FSPresetItem>) {
    this.curPresetItems = presetItems
    this.value = presetItems.code
    this.handleChange(this.value)
  }

  handleColumnPreset({ selected: presetItems }: XcHelpResult<FSPresetItem>) {
    this.curPresetItems = presetItems
    this.value = presetItems.id
    this.handleChange(this.value)
  }
}

@Pipe({ name: 'colValues' })
export class ColValuesPipe implements PipeTransform {
  transform(data: any[], col: string): any {
    if (data && data.map) return Array.from(new Set(data.map(i => i[col])))
  }
}
